function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M22 7.81v6.69H12V2h4.19C19.83 2 22 4.17 22 7.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 9.5V22H7.81C4.17 22 2 19.83 2 16.19V9.5h10z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 2v7.5H2V7.81C2 4.17 4.17 2 7.81 2H12zm10 12.5v1.69c0 3.64-2.17 5.81-5.81 5.81H12v-7.5h10z"
})));